<template>
  <div>
    <a-spin :spinning="loading">
      <a-form layout="vertical">
        <a-form-item label="发卡备注">
          <a-textarea
            v-model="form.issue_card_remark"
            :rows="8"
            placeholder="填写与该客户发卡相关的内部备注"
          />
        </a-form-item>
        <a-form-item label="销卡备注">
          <a-textarea
            v-model="form.cancel_card_remark"
            :rows="8"
            placeholder="填写与该客户销卡相关的内部备注"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            :loading="saving"
            @click="save"
          >
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-spin>
  </div>
</template>

<script>
import {
  findAgentOperationRemarks,
  updateAgentOperationRemarks
} from '@/api/agent'

export default {
  name: 'AgentOperationRemarks',
  data() {
    return {
      loading: false,
      saving: false,
      form: {
        issue_card_remark: '',
        cancel_card_remark: ''
      }
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    }
  },
  watch: {
    agentId() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      findAgentOperationRemarks(this.agentId)
        .then((res) => {
          if (res.code === 0) {
            this.form.issue_card_remark = res.data.issue_card_remark || ''
            this.form.cancel_card_remark = res.data.cancel_card_remark || ''
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      updateAgentOperationRemarks(this.agentId, this.form)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg || '保存成功')
          }
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
